export default {"src":"/_next/static/media/Dr.Shailendra.f305cc9f.JPG","height":4000,"width":6000,"blurWidth":0,"blurHeight":0};